$(document).ready(function () {
  // Prepend General Message Banner to Header
  $(".generalmessage").prependTo("header");

  // Ticket Button rename
  $(".ticket").text("Tickets");

  // Ticket Site Javascript
  const getURL = location.pathname.indexOf("default.aspx");
  const baseUrl = SITEBASEURL + "p/tickets";
  const customUrl = "https://schedulesite.com/";
  
  if (getURL >= 0 || location.pathname == "/") {
    window.location = baseUrl;
  }

  // Lineup Module modification

  function appendHeadline() {
    const lineup = $(".featureLineupContainer");

    lineup.each((index, item) => {
      const imageContainer = $(item).find(".featureLineupImage");
      const headline = $(item).find(".featureLineup-headline");
      $(headline).appendTo(imageContainer);

      // move more button
      const description = $(item).find(".featureLineup-text");
      const descriptionText = $(description).text();
      const moreButton = $(item).find(".featureLineup-more");
      const descriptionSpan = $('<span></span>').text(descriptionText);
      description.empty();
      description.append(descriptionSpan);
      description.append(moreButton);
    });
  }

  $(document).ready(function () {
    $(".header-logo").attr("href", customUrl);
    appendHeadline();
  });

  

  // Ticket btn added to footer
  $(".footer-navigation").prepend(
    '<span class="footer-navigation__separator">|</span>'
  );
  $(".footer-navigation").prepend(`
    <li class="topitem  " aria-haspopup="false">
    <a id="uc_footer_uc_footerWidgetContainer_ctl00_rptr_footNavStandard_nl_0_hlnk_heading_0" href="${baseUrl}">Tickets</a>
    </li>`);
});
